import { render, staticRenderFns } from "./the-created-type.vue?vue&type=template&id=c60c8a5c&scoped=true&"
import script from "./the-created-type.vue?vue&type=script&lang=js&"
export * from "./the-created-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60c8a5c",
  null
  
)

export default component.exports